import React, { Component } from 'react';
import ColorBlock from '../color-block/ColorBlock';
import { Row, Col, Input } from 'react-materialize';
import MetricSelect from './MetricSelect';
import $ from 'jquery';

const themesDef = {
        neonGreen: ['#00ffff', '#52f0fd', '#6fe0fc', '#83d2fa', '#54cee1', '#00c8cb', '#00bec0', '#00b4b5', '#00a9ab', '#009fa0', '#009595', '#008b8b'],
        eclipse: ['#f6efb4', '#dbe6b6', '#c2deb8', '#a9d4bb', '#91c9be', '#7abec1', '#66b3c5', '#52a5ca', '#4398d0', '#378ad8', '#3379e4'],
        candy: ['#ffb6b9', '#fdc0c0', '#fac8c5', '#f4ceca', '#edd3cd', '#e4d6cf', '#d9d7d0', '#cdd8d1', '#bfd7d0', '#b0d4ce', '#9fd1cb', '#8dccc8', '#78c7c4', '#61c0bf'],
        nightly: ['#11cbd7', '#64d6dc', '#8cdedf', '#a9e3e0', '#c2e4dd', '#d6dfd6', '#e7d4ca', '#f4c2b8', '#fda79f', '#ff817f', '#fa4659'],
        macarons: ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa', '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050', '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'],
        vintage: ['#d87c7c', '#919e8b', '#d7ab82', '#6e7074', '#61a0a8', '#efa18d', '#787464', '#cc7e63', '#724e58', '#4b565b'],
        roma: ['#e01f54', '#001852', '#f5e8c8', '#b8d2c7', '#c6b38e', '#a4d8c2', '#f3d999', '#d3758f', '#dcc392', '#2e4783', '#82b6e9', '#ff6347', '#a092f1', '#0a915d', '#eaf889', '#6699ff', '#ff6666', '#3cb371', '#d5b158', '#38b6b6'],
        green: ['#00ff7f', '#2bdb77', '#32bd6c', '#2fa35c', '#288c47', '#1c772c', '#006400'],
        intense: ['#0095b7', '#a0b774', '#f4c658', '#fe8b3e', '#cf2f23', '#756c56', '#007896', '#47a694', '#f9a94b', '#ff6b30', '#e94d29', '#005b76'],
        purple: ['#6495ed', '#6297dc', '#6097ce', '#5e93c2', '#5d8db9', '#5c84b2', '#5c78ad', '#5c6aaa', '#5a58aa', '#5742ac', '#4f25af']

}

export default class ColorPanel extends Component {
    
    onClickBlock(theme,event){

        this.props.onChangeAttribute({colorTheme:theme});
    }
    onChangeColorType(event){
        this.props.onChangeAttribute({colorType:event.target.value});
    }
    onChangeColorMetric(metric){
        this.props.onChangeConfig({colorMetric:metric});
    }
    hasColorMetricSupport(chartType){
        switch(chartType){
            case 'Area Line':
            case 'Bars and Line':
            case 'Trend':
            case 'Multimetric Trend':
            case 'Multimetric Area Line':
            case 'Multimetric Clustered Bars':
            case 'Multimetric Stacked Bars':
            case 'Stacked Bars':
            case 'Clustered Bars':
                return false;
            default:
                return true;
        }
    }

    componentDidMount(){
        setTimeout(() => {
            $('.dropdown-content.select-dropdown').css({'min-width':200})
        }, 200)
    }

    componentDidUpdate(){
        setTimeout(() => {
            $('.dropdown-content.select-dropdown').css({'min-width':200})
        }, 200)
    }

    render(){
        return <div className="chart-editor-panel">
            <Row>
                <h6>Color Type:</h6>
                <Input
                    l={6} m={6} s={6}
                    name="colorType"
                    type="radio"
                    label="Category"
                    value="sequential"
                    className="with-gap"
                    checked={this.props.colorType === 'sequential'}
                    onChange={this.onChangeColorType.bind(this)}/>
                <Input
                    l={6} m={6} s={6}
                    name="colorType"
                    type="radio"
                    label="Metric"
                    value="metric"
                    className="with-gap"
                    checked={this.props.colorType === 'metric'}
                    disabled={!this.hasColorMetricSupport(this.props.chartStyle)}
                    onChange={this.onChangeColorType.bind(this)}/>
            </Row>
            {this.props.colorType === 'metric' &&
                <MetricSelect
                    title="Metric:"
                    value={this.props.colorMetric}
                    metricList={this.props.metricList}
                    onChange={this.onChangeColorMetric.bind(this)}/>
            }
            <div className="ce-color-themes-ct">
                {Object.keys(themesDef).map((k,idx) => {
                    return <div key={"color-block-ct-" + idx} className="ce-color-block-ct"><ColorBlock key={"color-block" + idx} colors={themesDef[k]} selected={k == this.props.theme} onClick={this.onClickBlock.bind(this,k)}/></div>
                })}
            </div>
            
            </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/ColorPanel.jsx